import React from "react";
import { Route, Routes } from "react-router-dom";
import AlumniScreen from "./WelcomeScreen";
import AlumniConnect from "./AlumniConnect";
import AlumniProfile from "./AlumniProfile";
import UserProfile from "./UserProfile";
import Connect from "../Connect";

function AlumniLoggedScreen() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<AlumniScreen />} />
        <Route path="connect/*" element={<Connect />} />
        <Route path="user-profile" element={<AlumniProfile />} />
        <Route path="/profile" element={<UserProfile/>} />

      </Routes>
    </div>
  );
}

export default AlumniLoggedScreen;
